(function($)
{
    $.extend(true, orion, {
        api: {
            checkout: {
                summary: {}
            }
        }
    });

    var
        api = orion.api.checkout.summary,
        uri = '/api-checkout/summary.html';

    function read(data)
    {
        var
            promise = $.ajax(uri, {
                'method': 'GET',
                'data': data || {},
            });

        return promise;
    }

    api.read = read;
})(jQuery);
